<template>
<m-pageframe
    title="Export Communication Log"
>
<v-container>

    
    <m-edit-date
        label="Start Date"
        v-model="start_date"
    />


    <m-edit-date
        label="Stop Date"
        v-model="stop_date"
    />

    <v-select
        label="RedChirp Phone Number"
        :items="endpoints"
        v-model="endpoint"
    />
   

    <div
        style="text-align: right"
    >
        <v-btn
            color="primary"
            v-on:click="onClickExport"
            :disabled="endpoint == null"
        >
            Export Communication Log
        </v-btn>
    </div>

</v-container>
</m-pageframe>
</template>

<script>
const Time = require('@/js/time.js');

export default {
    data() {
        return {
            start_date: null,
            stop_date: null,
            endpoint: null,
            endpoints: [],
        }
    },
    
    mounted () {
        let date = new Date();

        this.start_date = Time.toISOFirstDayOfMonth(new Date());
        this.stop_date = Time.toISOLastDayOfMonth(new Date());   

        this.$rc.showSpinner();
        
        this.$rc.rest(
            'LIST: /api/v1/organizations/profile/endpoints',
        
            {
                'organization_id': this.$route.params.organization_id
            },
        
            (data) => {
                this.$rc.hideSpinner();

                let endpoints = [];

                for ( let i = 0; i < data.results.length; i++ )
                {
                    let pe = this.$rc.pretty(data.results[i].endpoint, 'endpoint');

                    endpoints.push({
                        'value' : data.results[i].endpoint,
                        'text' : pe+": "+data.results[i].assignment_label
                    });
                }

                this.endpoints = endpoints;
            },
        
            () => {
                this.$rc.hideSpinner();
                this.$rc.alert('Error','Unable to complete API call');
            },
        );
    },

    methods: {

       onClickExport()
       {
            this.$rc.excelExport(
                    'EXPORT: /api/v1/compliance/start-excel-export-communication-log',
                    {
                        'organization_id' : this.$route.params.organization_id,
                        'start' : this.start_date,
                        'stop' : this.stop_date,
                        'endpoint' : this.endpoint
                    }
                );
       },
           
    },
}
</script>

<style lang="scss" scoped>
</style>